import React, { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import ContactUs from "./pages/ContactUs";
import Help from "./pages/Help";
import HelpArticles from "./pages/HelpArticles";
import HelpArticle from "./pages/HelpArticle";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermsOfService from "./pages/TermsOfService";
import ListingGuidelines from "./pages/ListingGuidelines";
import { reset } from "./redux/templete/authSlice";

function ToastWatcher() {
  const dispatch = useDispatch();
  const { isSuccess, isError, message } = useSelector(
    (state) => state.authReducer
  );

  useEffect(() => {
    if (isSuccess === true && message !== "") {
      toast.success(message);
      dispatch(reset());
    } else if (isError === true && message !== "") {
      toast.error(message);
      dispatch(reset());
    }
  }, [dispatch, isError, isSuccess, message]);

  return null;
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ToastWatcher />
        <Routes>
          <Route path="/" element={<Navigate to="/help" replace />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/help" element={<Help />} />
          <Route path="/help/articles/:a" element={<HelpArticles />} />
          <Route path="/help/article/:a" element={<HelpArticle />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-use" element={<TermsOfService />} />
          <Route path="/listing-guidelines" element={<ListingGuidelines />} />
          <Route path="*" element={<Navigate to="/help" replace />} />
        </Routes>
        <ToastContainer />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
